import BrandStorefrontPage from "@faire/prototype-playground/workspace/ji/brand-storefront";
import BrandStorefrontAssistantOpenPage from "@faire/prototype-playground/workspace/ji/brand-storefront-assistant";
import BrandStorefrontAssistantDeepDivePage from "@faire/prototype-playground/workspace/ji/brand-storefront-assistant-deep-dive";
import CompareProductsPage from "@faire/prototype-playground/workspace/ji/compare-products";
import CompareProductsExploration2Page from "@faire/prototype-playground/workspace/ji/compare-products-exploration-2";
import CompareProductsInSituPage from "@faire/prototype-playground/workspace/ji/compare-products-in-situ";
import CompareProductsIterationPage from "@faire/prototype-playground/workspace/ji/compare-products-iteration";
import PdpCompareExplorationPage from "@faire/prototype-playground/workspace/ji/pdp-compare-exploration";
import PlaygroundBrandAlignmentPage from "@faire/prototype-playground/workspace/ji/playground-brand-alignment";
import RetailerAssistantFabPage from "@faire/prototype-playground/workspace/ji/retailer-assistant-fab";
import SuperAssistantComparePage from "@faire/prototype-playground/workspace/ji/super-assistant-compare";
import VisualizingCompareInChatPage from "@faire/prototype-playground/workspace/ji/visualize-compare-in-chat";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
import { withCompassLayout } from "../../components/compass/withCompassLayout";

const AiChatExplorationPage = withCompass(
  () => import("../../pages/AiChatExplorationPage")
);
// RetailerLayout's global nav calls useCompass, so this route needs the provider.
// Wrapped like its sibling: the page mounts `RetailerGlobalNavLoggedIn`, which calls
// `useCompass`, and that throws outside a provider.
const AssistantRefinementCanvasPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/assistant-refine-canvas/Page")
);

import ElevationExplorationOldPlaygroundPage from "@faire/prototype-playground/workspace/ji/elevation-exploration-old-playground";

const AssistantCategoryNavRefinementPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/assistant-category-nav/Page")
);
const AssistantCompareCanvasPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/assistant-compare-canvas/Page")
);

import RaMoreLikeThisV2Page from "@faire/prototype-playground/workspace/ji/ra-more-like-this-v2";

const AssistantCompareV2Page = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/assistant-compare-v2/Page")
);
const AssistantSearchCanvasPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/assistant-search-canvas/Page")
);
const CanvasFromPdpPage = withCompass(
  () => import("@faire/prototype-playground/workspace/ji/canvas-from-pdp/Page")
);
const RetailerAssistantMoreLikeThisPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/retailer-assistant-more-like-this/Page")
);
const RetailerAssistantMoreLikeThisUxrPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/retailer-assistant-more-like-this-uxr/Page")
);
const AskYourAssistantAltEntryPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/ask-your-assistant-alt-entry/Page")
);
const AskYourAssistantProminentPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/ask-your-assistant-prominent/Page")
);
const RetailerPdpPage = withCompass(
  () => import("@faire/prototype-playground/workspace/ji/retailer-pdp/Page")
);
const RetailerPdpAssistantPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/retailer-pdp-assistant/Page")
);
const RetailerPdpAssistantOpenV2Page = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ji/retailer-pdp-assistant-v-2/Page")
);
const B2BuyPage = withCompass(() => import("../../pages/B2BuyPage"));
const BulkEditorPage = lazy(() => import("../../pages/faire/BulkEditorPage"));
const BulkEditorTemplate = lazy(
  () => import("../../pages/faire/templates/BulkEditorTemplate")
);
const CollectionCreatorPage = lazy(
  () => import("../../pages/CollectionCreatorPage")
);
const CompassChatInteractionDetailsPage = lazy(
  () => import("../../pages/CompassChatInteractionDetailsPage")
);
const CompassInteractionExplorationPage = withCompass(
  () => import("../../pages/CompassInteractionExplorationPage")
);
const FairePlusLandingPage = lazy(
  () => import("../../pages/faire/FairePlusLandingPage")
);
const IntraterTop5Page = lazy(() => import("../../pages/IntraterTop5Page"));
const OrderDetailPage = lazy(() => import("../../pages/faire/OrderDetailPage"));
const OrderDetailTemplate = lazy(
  () => import("../../pages/faire/templates/OrderDetailTemplate")
);
const OrdersListPage = lazy(() => import("../../pages/faire/OrdersListPage"));
const OrdersListTemplate = lazy(
  () => import("../../pages/faire/templates/OrdersListTemplate")
);
const PDPChatFeb24Page = withCompass(() => import("../../pages/PDPChatFeb24"));
const Playground10LaunchPage = lazy(
  () => import("../../pages/Playground10LaunchPage")
);
const ProactiveFairePlusPage = lazy(
  () => import("../../pages/faire/ProactiveFairePlusPage")
);
const ProductsTemplate = lazy(
  () => import("../../pages/faire/templates/ProductsTemplate")
);
const RetailGrowthJamPage = withCompass(
  () => import("../../pages/RetailGrowthJamPage")
);
const RetailerFlashSession227Page = withCompass(
  () => import("../../pages/RetailerFlashSession227")
);
const ReviewToAcceptPage = lazy(
  () => import("../../pages/faire/ReviewToAcceptPage")
);
const SuperAssistantEntrySurfacePage = withCompass(
  () => import("../../pages/SuperAssistantEntrySurfacePage")
);
const UpmarketRetailerLandingPage = withCompass(
  () => import("../../pages/UpmarketRetailerLandingPage")
);
const CompassSuperAssistantPOCPage = withCompass(
  () => import("../../pages/CompassSuperAssistantPOCPage")
);
const IndexPage = lazy(() => import("../../pages/IndexPage"));
const TemplatePage = withCompassLayout(
  () => import("../../pages/TemplatePage")
);
const SuperAssistantApril24FlashSessionPage = withCompass(
  () => import("../../pages/SuperAssistantApril24FlashSessionPage")
);
const VariantSwitcherV2Page = lazy(
  () => import("../../pages/VariantSwitcherV2Page")
);
const SuperAssistantMegaPrototypePage = withCompass(
  () => import("../../pages/SuperAssistantMegaPrototypePage")
);

export function JohnIntraterRoutes() {
  return (
    <Switch>
      <Route path="/ji/compass-prototype" component={TemplatePage} />
      <Route path="/ji/retail-growth-jam" component={RetailGrowthJamPage} />
      <Route path="/ji/faire/bulk-editor" component={BulkEditorPage} />
      <Route
        exact
        path="/ji/faire/reactive-onboarding"
        component={OrdersListPage}
      />
      <Route
        path="/ji/faire/reactive-onboarding/:orderId"
        component={OrderDetailPage}
      />
      <Route path="/ji/faire/faire-plus" component={FairePlusLandingPage} />
      <Route
        path="/ji/faire/proactive-faire-plus"
        component={ProactiveFairePlusPage}
      />
      <Route path="/ji/faire/review-to-accept" component={ReviewToAcceptPage} />
      <Route
        exact
        path="/ji/faire/templates/orders"
        component={OrdersListTemplate}
      />
      <Route
        path="/ji/faire/templates/orders/:orderId"
        component={OrderDetailTemplate}
      />
      <Route
        path="/ji/faire/templates/bulk-editor"
        component={BulkEditorTemplate}
      />
      <Route path="/ji/faire/templates/products" component={ProductsTemplate} />
      <Route
        path="/ji/upmarket-retailer-landing"
        component={UpmarketRetailerLandingPage}
      />
      <Route
        path="/ji/compass-interaction-exploration"
        component={CompassInteractionExplorationPage}
      />
      <Route
        path="/ji/compass-chat-interaction-details"
        component={CompassChatInteractionDetailsPage}
      />
      <Route path="/ji/intrater-top-5" component={IntraterTop5Page} />
      <Route path="/ji/pdp-chat-feb-24" component={PDPChatFeb24Page} />
      <Route
        path="/ji/playground-1-0-launch-page"
        component={Playground10LaunchPage}
      />
      <Route path="/ji/b2buy" component={B2BuyPage} />
      <Route path="/ji/brand-storefront" component={BrandStorefrontPage} />
      <Route
        path="/ji/retailer-flash-session-2-27"
        component={RetailerFlashSession227Page}
      />
      <Route path="/ji/ai-chat-exploration" component={AiChatExplorationPage} />
      <Route
        path="/ji/ask-your-assistant-alt-entry"
        component={AskYourAssistantAltEntryPage}
      />
      <Route
        path="/ji/ask-your-assistant-prominent"
        component={AskYourAssistantProminentPage}
      />
      <Route
        path="/ji/assistant-category-nav"
        component={AssistantCategoryNavRefinementPage}
      />
      <Route
        path="/ji/assistant-compare-canvas"
        component={AssistantCompareCanvasPage}
      />
      <Route
        path="/ji/assistant-compare-v2"
        component={AssistantCompareV2Page}
      />
      <Route
        path="/ji/assistant-refine-canvas"
        component={AssistantRefinementCanvasPage}
      />
      <Route
        path="/ji/assistant-search-canvas"
        component={AssistantSearchCanvasPage}
      />
      <Route
        path="/ji/brand-storefront-assistant"
        component={BrandStorefrontAssistantOpenPage}
      />
      <Route
        path="/ji/brand-storefront-assistant-deep-dive"
        component={BrandStorefrontAssistantDeepDivePage}
      />
      <Route path="/ji/canvas-from-pdp" component={CanvasFromPdpPage} />
      <Route
        path="/ji/compass-buying-assistant"
        component={AiChatExplorationPage}
      />
      <Route
        path="/ji/super-assistant-entry-surface"
        component={SuperAssistantEntrySurfacePage}
      />
      <Route
        path="/ji/compass-super-assistant-poc"
        component={CompassSuperAssistantPOCPage}
      />
      <Route path="/ji/collection-creator" component={CollectionCreatorPage} />
      <Route exact path="/ji/og-index" component={IndexPage} />
      <Route path="/ji/og-index/experimental" component={IndexPage} />
      <Route path="/ji/og-index/patterns" component={IndexPage} />
      <Route
        path="/ji/pdp-compare-exploration"
        component={PdpCompareExplorationPage}
      />
      <Route path="/ji/compare-products" component={CompareProductsPage} />
      <Route
        path="/ji/compare-products-exploration-2"
        component={CompareProductsExploration2Page}
      />
      <Route
        path="/ji/compare-products-in-situ"
        component={CompareProductsInSituPage}
      />
      <Route
        path="/ji/compare-products-iteration"
        component={CompareProductsIterationPage}
      />
      <Route path="/ji/elevation-exploration-old-playground" component={ElevationExplorationOldPlaygroundPage} />
      <Route
        path="/ji/playground-brand-alignment"
        component={PlaygroundBrandAlignmentPage}
      />
      <Route path="/ji/ra-more-like-this-v2" component={RaMoreLikeThisV2Page} />
      <Route
        path="/ji/retailer-assistant-fab"
        component={RetailerAssistantFabPage}
      />
      <Route
        path="/ji/retailer-assistant-more-like-this"
        component={RetailerAssistantMoreLikeThisPage}
      />
      <Route
        path="/ji/retailer-assistant-more-like-this-uxr"
        component={RetailerAssistantMoreLikeThisUxrPage}
      />
      <Route path="/ji/retailer-pdp" component={RetailerPdpPage} />
      <Route
        path="/ji/retailer-pdp-assistant"
        component={RetailerPdpAssistantPage}
      />
      <Route
        path="/ji/retailer-pdp-assistant-v-2"
        component={RetailerPdpAssistantOpenV2Page}
      />

      <Route
        path="/ji/super-assistant-april-24-flash-session"
        component={SuperAssistantApril24FlashSessionPage}
      />
      <Route
        path="/ji/super-assistant-compare"
        component={SuperAssistantComparePage}
      />
      <Route path="/ji/variant-switcher-v2" component={VariantSwitcherV2Page} />
      <Route
        path="/ji/super-assistant-mega-prototype"
        component={SuperAssistantMegaPrototypePage}
      />
      <Route
        path="/ji/visualize-compare-in-chat"
        component={VisualizingCompareInChatPage}
      />
    </Switch>
  );
}

export const slug = "ji";
